import React from 'react';
import { twMerge } from 'tailwind-merge';

import { TextArea as TextAreaBase } from '../TextArea';
import { FieldLabel } from './FieldLabel';

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  label: string;
  explanation?: string;
  name: string;
}

export function Textarea(props: Props) {
  const { className, label, explanation, name, required, ...rest } = props;

  return (
    <label className={twMerge('block', 'w-full', className)} htmlFor={name}>
      <FieldLabel label={label} required={required} explanation={explanation} />
      <div className="mt-1">
        <TextAreaBase
          id={name}
          name={name}
          className="w-full"
          required={required}
          {...rest}
        />
      </div>
    </label>
  );
}
